module.exports = __webpack_public_path__ + "img/search-relatives-icon.png";